<template>
    <div>
        <sau-vds-console class="pb-3"></sau-vds-console>
    </div>
</template>
<script>
import CommonAccess from '../common/_Access';
import VdsConsole from './_Console';
export default {
    components: {
        'sau-common-access': CommonAccess,
        'sau-vds-console': VdsConsole
    },
    data() {
        return {
        }
    },
}
</script>
<style>
</style>